export default {"src":"/_next/static/media/hot-product-icon.60a1affe.svg","height":18,"width":15,"blurWidth":0,"blurHeight":0};